<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.invitation")}}</span>
    <div v-if="dataLoaded" class="sheet-container">
      <div class="d-flex flex-xl-row flex-lg-row flex-column justify-start  mt-4 mr-xl-16 mr-lg-12 ">
        <v-text-field
          class="mt-3"
          v-model="emailSearchTerm"
          append-icon="mdi-close"
          label="Email"
        >
          <template v-slot:append>
            <v-btn icon @click="searchByEmail()">
              <v-icon color="black">
                mdi-magnify
              </v-icon>
            </v-btn>
          </template>
        </v-text-field>
        <v-select
          class="ma-6"
          v-model="invitationFilter"
          :items="[{text:$t(`aveine-invitation.title.all`), value:null},
                    {text:$t(`aveine-invitation.title.ambassador`), value:'ambassador'},
                    {text:$t(`aveine-invitation.title.superAmbassador`), value:'super_ambassador'},
                    {text:$t(`aveine-invitation.title.domain`), value:'domain'}]"
          :label="$t('aveine-invitation.title.invitationType')"
        ></v-select>
        <v-select
          class="ma-6"
          v-model="sortInvitation"
          :items="[{text:$t(`aveine-invitation.title.desc`), value:'desc'},
                  {text:$t(`aveine-invitation.title.asc`), value:'asc'}]"
          :label="$t('aveine-invitation.title.sort')"
        ></v-select>
      </div>
      <AveineInvitationManagement :APIbaseURL="APIbaseURL" :invitations="invitations" :adminMode="true"/>
      <div class="text-center">
        <v-pagination
          v-model="currentPage"
          :length="paginationLength"
          :total-visible="paginationLength < 7 ? paginationLength : 7"
        ></v-pagination>
      </div>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineInvitationManagement } from 'aveine-invitation';
import { Invitation } from 'aveine-toolbox';
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      invitations: [],
      invitationFilter: null,
      sortInvitation: "desc",
      currentPage: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
      paginationLength: 0,
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST,
      emailSearchTerm: "",
    }
  },
  name: 'Invitation',
  components: {
    AveineInvitationManagement
  },
  watch: {
    invitationFilter () {
      this.loadInvitations();
    },
    sortInvitation () {
      this.loadInvitations()
    },
    async currentPage (val) {
      this.dataLoaded= false;
      if (this.$route.query.search) {
        this.$router.push({ path: '/authenticated/invitations', query: { page: val, search: this.$route.query.search }});
      } else {
        this.$router.push({ path: '/authenticated/invitations', query: { page: val }});

      }
    },
  },
  
  async mounted() {
    if (this.$route.query.search) { this.emailSearchTerm = this.$route.query.search}
    this.loadInvitations();
  },
  methods: {
    async searchByEmail () {
      this.dataLoaded= false;
      this.$router.push({ path: '/authenticated/invitations', query: { search: this.emailSearchTerm }});
      this.loadInvitations()
    },
    async loadInvitations () {
      try {

        this.invitations = [];
        this.dataLoaded = false;
        
        let params =  
        {
          "page[number]": this.$route.query.page || 1,
          "page[size]": 40,
          "include": "user,invited-by.ambassador,invited-by.super-ambassador,invited-by.domain",
        };

        if (this.$route.query.search) {
          params['filter[email]'] = this.$route.query.search
        }

        if (this.invitationfilter)
            params[`filter[invitation_type]`] = this.invitationfilter

        if (this.sortInvitation) {
          if (this.sortInvitation == "desc")
            params[`sort`] = "-created-at"
          else if  (this.sortInvitation == "asc")
            params[`sort`] = "created-at"
        }


        let invitations = await Invitation.api().get(`invitations?lang=${this.$i18n.locale}`, {
            params
          }
        );

        const that = this;

        invitations.response.data.map(async function(data){
          let invitation = await Invitation.query().whereId(data.id).withAllRecursive().first();
          let invitedBy = {};

          if (invitation.invited_by) {
            if (invitation.invited_by.ambassador) {
              invitedBy =  {
                name: invitation.invited_by.ambassador.name,
                route: `AmbassadorRead`,
                id: invitation.invited_by.ambassador.id
              };
            } else if (invitation.invited_by.super_ambassador) {
              invitedBy =  {
                name: invitation.invited_by.super_ambassador.name,
                route: `SuperAmbassadorRead`,
                id: invitation.invited_by.super_ambassador.id
              };
            } else if (invitation.invited_by.domain) {
              invitedBy =  {
                name: invitation.invited_by.domain.name,
                route: `DomainRead`,
                id: invitation.invited_by.domain.id
              };
            } else if (invitation.invited_by.auth0_id && invitation.invited_by.auth0_id.startsWith("waad")) {
              invitedBy.name = "Aveine";
            }
          } else {
            invitedBy = null;
          }
          // Store the date 7 days from now to filter out invitations and show recently finished ones
          let currentDate = new Date();
          const lastWeek = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 7);

          if (!invitation.user || (invitation.user && new Date(invitation.updated_at) >= lastWeek)) {
            that.invitations.push({
              data: invitation,
              updated_at: invitation.updated_at,
              invited_by: invitedBy,
              entity_route: `${invitation.invitation_type}s/read/${invitation.entity_id}`,
              visited: invitation.visited ? "visited" : null,
              payed: invitation.payment ? "payed" : null,
              completed: invitation.user ? "completed" : null
            })
          }
        })
        this.paginationLength = invitations.response.data.meta.last
        this.dataLoaded = true;
      } catch (errors) {
        this.dataLoaded = true;
        errorHandler(errors, this)
      }
    }
  }
}
</script>
